import Swiper from 'swiper';
import { Navigation, A11y, Keyboard, Autoplay } from 'swiper/modules';

export function initEventsSlider() {
  const sectionEl = document.querySelector('.home-events');
  if (!sectionEl) {
    return;
  }

  const sliderEl = sectionEl.querySelector('.home-events__slider');
  if (!sliderEl) {
    return;
  }

  const slides = sliderEl.querySelectorAll('.swiper-slide');
  if (slides.length <= 1) {
    const navButtons = sectionEl.querySelectorAll('.home-events__nav-btn');
    navButtons.forEach((btn) => {
      btn.style.display = 'none';
    });
    return;
  }

  const prevBtn = sectionEl.querySelector('.home-events__nav-btn--prev');
  const nextBtn = sectionEl.querySelector('.home-events__nav-btn--next');

  new Swiper(sliderEl, {
    modules: [Navigation, A11y, Keyboard, Autoplay],
    slidesPerView: 1,
    spaceBetween: 30,
    speed: 600,
    loop: slides.length > 1,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    a11y: {
      prevSlideMessage: 'Poprzedni slajd',
      nextSlideMessage: 'Następny slajd',
      firstSlideMessage: 'To jest pierwszy slajd',
      lastSlideMessage: 'To jest ostatni slajd',
    },
    navigation: {
      prevEl: prevBtn,
      nextEl: nextBtn,
    },
  });
}
